import { useState, useEffect } from 'react';

const guidMap = {};

export default function getGuid(key) {
  const guid = (guidMap[key] || 0) + 1;
  guidMap[key] = guid;
  return `${key}-${guid}`;
}

export function useGuid(key) {
  const [guid, setGuid] = useState(undefined);

  useEffect(() => {
    setGuid(getGuid(key));
  }, [key]);

  return guid;
}
